// import React, { useRef, useEffect } from "react";

// import { useSelector } from "react-redux";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import { useGetSubModuleMutation } from "store/features/process/processApi";

// import EmptyUserCard from "components/skeleton/EmptyUserCard";
// import { ListItem, ListItemText, CardContent, List, Grid, Box, Typography } from "@mui/material";
// import { Tooltip, message } from "antd";

// import cancelIcon from "assets/images/icons/deactivated.svg";
// import { encodeQueryParamData } from "utils/utils";

// export default function ModuleConsole() {
//   const location = useLocation();
//   const { pathname } = location;

//   const { module } = useParams();
//   const navigate = useNavigate();
//   const verticalCodeListRef = useRef([]);
//   const userId = useSelector((state) => state.auth.userId);
//   const { pSearchValue } = useSelector((state) => state.main);
//   const creatorOrganizationId = useSelector((state) => state.profile.profileData?.creatorOrganizationId);

//   const [getSubModule, { data: subModuleList }] = useGetSubModuleMutation();

//   const handleClick = (process) => {
//     if (process?.permitted) {
//       if (process?.staticFormUrl?.startsWith("/static")) {
//         const queryParamData = encodeQueryParamData({ processCode: process?.codeProcess });
//         navigate(`${process?.staticFormUrl}/${queryParamData}`, { state: { processCode: process?.codeProcess } });
//       } else {
//         const queryParamData = encodeQueryParamData({ processCode: process?.codeProcess });
//         navigate(`/case-identity/${queryParamData}`, { state: { processCode: process?.codeProcess } });
//       }
//     } else {
//       message.error({
//         content: "You do not have permission to perform this action.",
//         icon: <img src={cancelIcon} alt="inactive" width="16px" height="16px" style={{ marginRight: "8px", verticalAlign: "sub" }} />,
//       });
//     }
//   };

//   const handleTooltip = (processName, companyCode) => {
//     let rmvStr = companyCode + "-";
//     let newProcessName = processName.replace(new RegExp("\\b" + rmvStr + "\\b", "gi"), "");
//     return newProcessName;
//   };

//   useEffect(() => {
//     if (creatorOrganizationId && userId && module) {
//       getSubModule({
//         codeCompany: creatorOrganizationId,
//         peopleOf: "userId",
//         value: userId,
//         menu: "lyn-process-create",
//         module: module,
//       });
//     }
//     //eslint-disable-next-line
//   }, [creatorOrganizationId, userId, module]);

//   let content = null;

//   if (subModuleList?.status === "SUCCESS") {
//     const verticalCodeMap = subModuleList?.lynProcessVerticalList.map((item) => {
//       return item?.code;
//     });

//     verticalCodeListRef.current = verticalCodeMap;
//   }

//   if (subModuleList?.status === "SUCCESS") {
//     const structureProcessVerticalCode = subModuleList?.lynProcessVerticalList?.find((item) => item?.name === "Console");

//     if (subModuleList?.lynPeopleProcessVerticalModuleList?.length > 0) {
//       content = (
//         <CardContent sx={{ py: 0, px: 0 }}>
//           <Grid container spacing={3} alignItems="center">
//             <Grid item xs={12}>
//               {subModuleList?.lynProcessModuleList?.map((subModule, index) => (
//                 <Box key={index} sx={{ mt: 2 }}>
//                   <Typography variant="h5" sx={{ mb: 3, fontSize: "1rem" }}>
//                     {subModule?.name}
//                   </Typography>

//                   <Box className="process-section" sx={{ backgroundColor: index % 2 === 0 ? "#e2ebf7" : "#eaefeb" }}>
//                     {" "}
//                     {/* borderLeft: `5px solid ${index % 2 === 0 ? "#03396c" : "#45a13b"}` */}
//                     {/* ------------ Old Code ----------- */}
//                     {/* <Grid key={index} container spacing={3}>
//                       {subModuleList?.lynMapPeopleProcessDetails
//                         ?.filter((solution) => solution.module === subModule.parent && solution.subModule === subModule.code && solution.vertical === structureProcessVerticalCode.code)
//                         ?.map((process, index) => (
//                           <Grid key={index} item xs={12} sm={6} md={3} lg={2} sx={{ display: "flex", alignItem: "center" }}>
//                             {process?.permitted ? (
//                               <Tooltip title={handleTooltip(process?.codeProcess, process?.codeCompany)}>
//                                 <Box
//                                   className="process-card-module"
//                                   sx={{
//                                     width: "100%",
//                                     bgcolor: "#ffffff",
//                                     cursor: "pointer",
//                                     // border: "1px solid #a3acb7",
//                                     // borderTop: `3px solid ${tabColor?.[verticalCodeListRef.current.findIndex((code) => code === process?.vertical)]}`,
//                                     "&:hover": {
//                                       backgroundColor: "#ffffff",
//                                     },
//                                   }}
//                                   onClick={() => {
//                                     handleClick(process);
//                                   }}
//                                 >
//                                   <List sx={{ px: 1.5, py: 0 }}>
//                                     <ListItem disablePadding>
//                                       <ListItemText
//                                         sx={{ mt: 0 }}
//                                         primary={<Typography variant="subtitle1">{process?.name}</Typography>}
//                                         secondary={
//                                           <Typography variant="caption" color="secondary">
//                                             last used {moment(process?.lastUse?.localDateTimeString).fromNow()}
//                                           </Typography>
//                                         }
//                                       />
//                                     </ListItem>
//                                   </List>
//                                 </Box>
//                               </Tooltip>
//                             ) : (
//                               <Tooltip title={handleTooltip(process?.codeProcess, process?.codeCompany)}>
//                                 <Box
//                                   className="process-card-module"
//                                   sx={{
//                                     width: "100%",
//                                     bgcolor: "#f7f3f3",
//                                     cursor: "pointer",
//                                     // border: "1px solid #a3acb7",
//                                     // borderTop: `3px solid ${tabColor?.[verticalCodeListRef.current.findIndex((code) => code === process?.vertical)]}`,
//                                     "&:hover": {
//                                       backgroundColor: "#f7f3f3",
//                                     },
//                                   }}
//                                   onClick={() => {
//                                     handleClick(process);
//                                   }}
//                                 >
//                                   <List sx={{ px: 1.5, py: 0 }}>
//                                     <ListItem disablePadding>
//                                       <ListItemText
//                                         sx={{ mt: 0 }}
//                                         primary={<Typography variant="subtitle1">{process?.name}</Typography>}
//                                         secondary={
//                                           <Typography variant="caption" color="secondary">
//                                             {process?.lastUse ? `last used ${moment(process?.lastUse?.localDateTimeString).fromNow()}` : "Never Used"}
//                                           </Typography>
//                                         }
//                                       />
//                                     </ListItem>
//                                   </List>
//                                 </Box>
//                               </Tooltip>
//                             )}
//                           </Grid>
//                         ))}
//                     </Grid> */}
//                     {/* -------------- New Code ---------------- */}
//                     <Grid key={index} container spacing={3}>
//                       {subModuleList?.lynMapPeopleProcessDetails
//                         ?.filter((solution) => solution.module === subModule.parent && solution.subModule === subModule?.code && solution.vertical === structureProcessVerticalCode?.code)
//                         ?.filter((filterProcess) => filterProcess?.name?.toLowerCase()?.includes(pSearchValue?.[pathname] ? pSearchValue?.[pathname]?.toLowerCase() : ""))
//                         ?.filter((itemStatus) => itemStatus.activationStatus === "Active")
//                         ?.map((process, index) => (
//                           <Grid key={index} item xs={12} sm={6} md={3} lg={2} sx={{ display: "flex", alignItem: "center" }}>
//                             {process?.permitted ? (
//                               <Tooltip title={handleTooltip(process?.codeProcess, process?.codeCompany)}>
//                                 <Box
//                                   className="process-card-module"
//                                   sx={{
//                                     width: "100%",
//                                     bgcolor: "#ffffff",
//                                     cursor: "pointer",
//                                     // border: "1px solid #a3acb7",
//                                     // borderTop: `3px solid ${tabColor?.[verticalCodeListRef.current.findIndex((code) => code === process?.vertical)]}`,
//                                     "&:hover": {
//                                       backgroundColor: "#ffffff",
//                                     },
//                                   }}
//                                   onClick={() => {
//                                     handleClick(process);
//                                   }}
//                                 >
//                                   <List sx={{ px: 1.5, py: 0 }}>
//                                     <ListItem disablePadding>
//                                       <ListItemText
//                                         sx={{ mt: 0 }}
//                                         primary={<Typography variant="subtitle1">{process?.name}</Typography>}
//                                         // secondary={
//                                         //   <Typography variant="caption" color="secondary">
//                                         //     last used {moment(process?.lastUse?.localDateTimeString).fromNow()}
//                                         //   </Typography>
//                                         // }
//                                       />
//                                     </ListItem>
//                                   </List>
//                                 </Box>
//                               </Tooltip>
//                             ) : (
//                               <Tooltip title={handleTooltip(process?.codeProcess, process?.codeCompany)}>
//                                 <Box
//                                   className="process-card-module"
//                                   sx={{
//                                     width: "100%",
//                                     bgcolor: "#f7f3f3",
//                                     cursor: "pointer",
//                                     // border: "1px solid #a3acb7",
//                                     // borderTop: `3px solid ${tabColor?.[verticalCodeListRef.current.findIndex((code) => code === process?.vertical)]}`,
//                                     "&:hover": {
//                                       backgroundColor: "#f7f3f3",
//                                     },
//                                   }}
//                                   onClick={() => {
//                                     handleClick(process);
//                                   }}
//                                 >
//                                   <List sx={{ px: 1.5, py: 0 }}>
//                                     <ListItem disablePadding>
//                                       <ListItemText
//                                         sx={{ mt: 0 }}
//                                         primary={<Typography variant="subtitle1">{process?.name}</Typography>}
//                                         // secondary={
//                                         //   <Typography variant="caption" color="secondary">
//                                         //     {process?.lastUse ? `last used ${moment(process?.lastUse?.localDateTimeString).fromNow()}` : "Never Used"}
//                                         //   </Typography>
//                                         // }
//                                       />
//                                     </ListItem>
//                                   </List>
//                                 </Box>
//                               </Tooltip>
//                             )}
//                           </Grid>
//                         ))}
//                     </Grid>
//                   </Box>
//                 </Box>
//               ))}
//             </Grid>
//           </Grid>
//         </CardContent>
//       );
//     } else {
//       content = <EmptyUserCard title="No Solution Found" />;
//     }
//   }

//   return content;
// }

import React, { useEffect, useRef } from 'react';

import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useGetSubModuleMutation } from 'store/features/process/processApi';
import { Box, CardContent, Grid, List, ListItem, ListItemText, Typography } from '@mui/material';
import { App, Tooltip } from 'antd';
import moment from 'moment';

import cancelIcon from 'assets/images/icons/deactivated.svg';
import EmptyUserCard from 'components/skeleton/EmptyUserCard';
import { encodeQueryParamData } from 'utils/utils';
import { solutionURLByVertical } from 'static-solutions/staticSolutionURLStore';

export default function ModuleConsole() {
	const location = useLocation();
	const { pathname } = location;
	const { message: messageApi } = App.useApp();

	const { module } = useParams();
	const navigate = useNavigate();
	const verticalCodeListRef = useRef([]);
	const userId = useSelector((state) => state.auth.userId);
	const { pSearchValue } = useSelector((state) => state.main);
	const creatorOrganizationId = useSelector((state) => state.profile.profileData?.creatorOrganizationId);

	const [getSubModule, { data: subModuleList }] = useGetSubModuleMutation();

	const handleClick = (process) => {
		if (process?.permitted) {
			const companyCode = process?.companyCode || localStorage.getItem('companyCode') || '';
			const pathCode = `${companyCode}-${process?.codeProcess}-${process?.version}`;
			const path = solutionURLByVertical?.[pathCode];

			if (path) {
				const queryParamData = encodeQueryParamData({ processCode: process?.codeProcess });
				navigate(`${path}/${queryParamData}`, { state: { processCode: process?.codeProcess } });
			} else {
				messageApi.error({
					content: 'No Page Found.',
					icon: <img src={cancelIcon} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
				});
			}
		} else {
			messageApi.error({
				content: 'You do not have permission to perform this action.',
				icon: <img src={cancelIcon} alt="inactive" width="16px" height="16px" style={{ marginRight: '8px', verticalAlign: 'sub' }} />,
			});
		}
	};

	const handleTooltip = (processName, companyCode) => {
		let rmvStr = companyCode + '-';
		let newProcessName = processName.replace(new RegExp('\\b' + rmvStr + '\\b', 'gi'), '');
		return newProcessName;
	};

	useEffect(() => {
		if (creatorOrganizationId && userId && module) {
			getSubModule({
				codeCompany: creatorOrganizationId,
				peopleOf: 'userId',
				value: userId,
				menu: 'lyn-process-create',
				module: module,
			});
		}
		//eslint-disable-next-line
	}, [creatorOrganizationId, userId, module]);

	let content = null;

	if (subModuleList?.status === 'SUCCESS') {
		const verticalCodeMap = subModuleList?.lynProcessVerticalList.map((item) => {
			return item.code;
		});

		verticalCodeListRef.current = verticalCodeMap;
	}

	if (subModuleList?.status === 'SUCCESS') {
		const structureProcessVerticalCode = subModuleList.lynProcessVerticalList.find((item) => item.name === 'Console');

		if (subModuleList?.lynPeopleProcessVerticalModuleList?.length > 0) {
			content = (
				<CardContent sx={{ py: 0, px: 0 }}>
					<Grid container spacing={3} alignItems="center">
						<Grid item xs={12}>
							{subModuleList?.lynProcessModuleList?.map((subModule, index) => (
								<Box key={index} sx={{ mt: 2 }}>
									<Typography variant="h5" sx={{ mb: 3, fontSize: '1rem' }}>
										{subModule?.name}
									</Typography>

									<Box className="process-section" sx={{ backgroundColor: index % 2 === 0 ? '#e2ebf7' : '#eaefeb' }}>
										{' '}
										{/* borderLeft: `5px solid ${index % 2 === 0 ? "#03396c" : "#45a13b"}` */}
										<Grid key={index} container spacing={3}>
											{subModuleList?.lynMapPeopleProcessDetails
												?.filter(
													(solution) =>
														solution?.module === subModule?.parent &&
														solution?.subModule === subModule?.code &&
														solution?.vertical === structureProcessVerticalCode?.code
												)
												?.filter((filterProcess) =>
													filterProcess?.name
														?.toLowerCase()
														?.includes(pSearchValue?.[pathname] ? pSearchValue?.[pathname]?.toLowerCase() : '')
												)
												?.map((process, index) => (
													<Grid key={index} item xs={12} sm={6} md={3} lg={2} sx={{ display: 'flex', alignItem: 'center' }}>
														{process?.permitted ? (
															<Tooltip title={handleTooltip(process?.codeProcess, process?.codeCompany)}>
																<Box
																	className="process-card-module"
																	sx={{
																		width: '100%',
																		bgcolor: '#ffffff',
																		cursor: 'pointer',
																		// border: "1px solid #a3acb7",
																		// borderTop: `3px solid ${tabColor?.[verticalCodeListRef.current.findIndex((code) => code === process?.vertical)]}`,
																		'&:hover': {
																			backgroundColor: '#ffffff',
																		},
																	}}
																	onClick={() => {
																		handleClick(process);
																	}}
																>
																	<List sx={{ px: 1.5, py: 0 }}>
																		<ListItem disablePadding>
																			<ListItemText
																				sx={{ mt: 0 }}
																				primary={<Typography variant="subtitle1">{process?.name}</Typography>}
																				secondary={
																					<Typography variant="caption" color="secondary">
																						last used{' '}
																						{moment(process?.lastUse?.localDateTimeString).fromNow()}
																					</Typography>
																				}
																			/>
																		</ListItem>
																	</List>
																</Box>
															</Tooltip>
														) : (
															<Tooltip title={handleTooltip(process?.codeProcess, process?.codeCompany)}>
																<Box
																	className="process-card-module"
																	sx={{
																		width: '100%',
																		bgcolor: '#f7f3f3',
																		cursor: 'pointer',
																		// border: "1px solid #a3acb7",
																		// borderTop: `3px solid ${tabColor?.[verticalCodeListRef.current.findIndex((code) => code === process?.vertical)]}`,
																		'&:hover': {
																			backgroundColor: '#f7f3f3',
																		},
																	}}
																	onClick={() => {
																		handleClick(process);
																	}}
																>
																	<List sx={{ px: 1.5, py: 0 }}>
																		<ListItem disablePadding>
																			<ListItemText
																				sx={{ mt: 0 }}
																				primary={<Typography variant="subtitle1">{process?.name}</Typography>}
																				secondary={
																					<Typography variant="caption" color="secondary">
																						{process?.lastUse
																							? `last used ${moment(process?.lastUse?.localDateTimeString).fromNow()}`
																							: 'Never Used'}
																					</Typography>
																				}
																			/>
																		</ListItem>
																	</List>
																</Box>
															</Tooltip>
														)}
													</Grid>
												))}
										</Grid>
									</Box>
								</Box>
							))}
						</Grid>
					</Grid>
				</CardContent>
			);
		} else {
			content = <EmptyUserCard title="No Solution Found" />;
		}
	}

	return content;
}
